// 2026-09-26 - FormuLearning - 스텝 명칭 단일 상수 (이슈 #95 단계 3-5)
// 파일 위치: frontend/src/lib/steps.ts
// 목적: 좌측 패널·메인 카드·LOAD·프로젝트 정보 모달 4곳에 중복돼 있던 명칭 배열을 한 곳에 둔다.
//   명칭 정본 = 6/2 회의 확정 구조(이슈 #1) + Step 7 Final Report(이슈 #59).

export const STEP_LABELS = [
  'Drug Profile',
  'Physicochemical Properties',
  'Target Design',
  'Formulation',
  'Design of Experiments',
  'PK Simulation',
  'Final Report',
] as const

/** 스텝 번호(1부터) → `Step N · Label` — 접힌 패널 번호 버튼 툴팁(UI UX §4.3). */
export function stepCaption(n: number): string {
  return `Step ${n} · ${STEP_LABELS[n - 1]}`
}
